export default "__VITE_ASSET__BED4uUR0__"